import * as React from "react";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../../utils/Firebase/Users/users.firebase";

const theme = createTheme();

export function SignUp() {
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const handleChange = (e) =>
    setValues({ ...values, [e.target.name]: e.target.value });
  const handleSignUp = async (event) => {
    event.preventDefault();
    try {
      await registerUser(values);
      alert("Registration successful. Please login.");
      navigate("/login");
    } catch (error) {
      const errorCode = error.code;
      setError(error.message);
      // alert(error.message);
      if (values.firstName === "") {
        alert("Please enter your first name.");
      } else if (values.lastName === "") {
        alert("Please enter your last name.");
      } else if (values.email === "") {
        alert("Please enter your email address.");
      } else if (values.password === "") {
        alert("Please enter your password.");
      } else if (errorCode == "auth/weak-password") {
        alert("Password is too weak.");
      } else if (errorCode == "auth/network-request-failed") {
        alert("Network connection failed.");
      } else if (errorCode == "auth/invalid-email") {
        alert("Email format is invalid");
      } else if (errorCode == "auth/email-already-in-use") {
        alert(
          "This email is already being used. Please use a different email account."
        );
      } else {
        alert(error.message);
      }
    }
  };
  const navigate = useNavigate();
  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const data = new FormData(event.currentTarget);
  //   console.log({
  //     email: data.get("email"),
  //     password: data.get("password"),
  //   });
  // };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <Box
            component="form"
            onSubmit={handleSignUp}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              value={values.firstName}
              onChange={handleChange}
              required
              fullWidth
              id="firstName"
              label="First Name"
              name="firstName"
              autoComplete=""
              autoFocus
            />
            <TextField
              value={values.lastName}
              onChange={handleChange}
              margin="normal"
              required
              fullWidth
              id="lastName"
              label="Last Name"
              name="lastName"
              autoComplete="lastName"
              autoFocus
            />
            <TextField
              value={values.email}
              onChange={handleChange}
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              value={values.password}
              onChange={handleChange}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign up
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  {/* Forgot password? */}
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href="#"
                  variant="body2"
                  onClick={() => {
                    navigate("/Login");
                  }}
                >
                  {"Already have an account? Sign In"}
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        My K Star
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
